export default {
  detail: '/gateway/capp/ActivityForAppRpcService/getPartnerActivityStrategyDetail'
}
